import * as React from 'react';
import './index.scss';
interface Props {
  children?: any;
}
const Pop: React.FC<Props> = props => (
  <div className='pop'>
    <div className='shadow'/>
    <div className='content'>{props.children}</div>
  </div>
)
export default Pop;